var _defs, _tspan;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCwr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500.00003,
    height: 150.12106,
    viewBox: "0 0 132.29166 39.719532",
    id: "svg8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(2.532959e-6,-257.28042)"
  }, /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "10.58333302px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 36.777084,
    y: 111.2625,
    id: "text12"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan14",
    x: 36.777084,
    y: 121.05208
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "10.58333302px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 66.410416,
    y: 130.04791,
    id: "text18"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan16",
    x: 66.410416,
    y: 139.83749,
    style: {
      strokeWidth: 0.26458332
    }
  })), /*#__PURE__*/React.createElement("g", {
    "aria-label": "\\uE1D2",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "360.46774292px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 9.011693
    },
    id: "text22"
  }, /*#__PURE__*/React.createElement("g", {
    "aria-label": "\\uE4F4",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "320.31881714px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 72.16536713
    },
    id: "text3945"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 4.8047797,257.28042 c -2.5625505,0 -4.804782232959,1.92192 -4.804782232959,4.48447 0,2.56255 2.242231732959,4.80478 4.804782232959,4.80478 H 30.109966 v 23.70359 c 0,3.52351 2.88287,6.7267 6.726695,6.7267 h 58.938663 c 3.523507,0 6.726696,-3.20319 6.726696,-6.7267 v -23.38327 c 0,-0.32032 0,-0.32032 25.30519,-0.32032 2.56255,0 4.48446,-2.24223 4.48446,-4.80478 0,-2.56255 -1.92191,-4.48447 -4.48446,-4.48447 z",
    style: {
      strokeWidth: 72.16536713
    },
    id: "path3947"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCwr);
export default __webpack_public_path__ + "static/media/cwr.eaf2e1cb7c0bc7f61017ebb25267b8ad.svg";
export { ForwardRef as ReactComponent };